import {Injectable} from '@angular/core';


export enum LocalStorageKeys {
    STAY_LOGGED_IN = 'stayLoggedIn',
    TOKEN = '_token',
    USER ='user',
    CONFIG = 'config',
    DEV_ACCESS_TOKEN = 'devAccessToken',
    SESSION_EXPIRE_AT = 'session_expire_at',
    IS_2FA_ENABLED = 'is_2fa_enabled',
    LOGIN_RETRY_EXPIRES_AT = 'login_retry_expires_at'
}


@Injectable({
    providedIn: 'root'
})

export class StorageService {
    constructor () {}



    /**
     * Add Item To Storage
     * @param key 
     * @param value 
     */
    addItem<T = unknown>(key: string, value: T){
        localStorage.setItem(key, JSON.stringify(value));
    }





    /**
     * Get Item From Storage
     * @param key 
     * @returns 
     */
    getItem(key: string){
        const data = localStorage.getItem(key);
        return data ?? null;
    }



    /**
     * Remove Item
     * @param key 
     */
    removeItem(key: string){
        localStorage.removeItem(key);
    }


    
    /**
     * Remove Items
     * @param keys 
     */
    removeItems(keys: string[]){
        keys.forEach(key => localStorage.removeItem(key));
    }



    /** Clear Storage */
    clearStorage(){
        localStorage.clear();
    }
}
